const o = {
  v1: "v1"
};
export {
  o as pTON_VERSION
};
//# sourceMappingURL=constants.js.map
